export default "<p>reportesupervisor works!</p>\n";